<template>
	<div>
		<div class="div1">
		<div class="front">
			<div style="height: 200px;">
				<div style="height: 60px;"></div>
				<el-row  type="flex" justify="center" align="middle">
					<el-col :span="6" class="el-col_bottom">
						<div>
							<img src="@/assets/logoname.png" style="width: 200px;">
						</div>
						<div class="divtime">
							<span>周一至周五  08:00 - 18:00</span>
							<!-- <span>{{currentTime}}</span> -->
						</div>
						
					</el-col>
					<el-col class="el-col_bottom" :span="2">
						
					</el-col>
					<el-col :span="10" class="el-col_bottom" style="color: #FFFFFF; text-align: left;">
						<div style="height: 30px;">
							<img src="@/assets/foot_1.png">
							<span> 地址: 河南省封丘县城关镇后北场</span>
						</div>
						<div style="height: 30px;">
							<img src="@/assets/foot_2.png">
							<span> 电话: 0373-8285361</span>
						</div>
						<div style="height: 30px;">
							<img src="@/assets/foot_3.png">
							<span> 信箱: qzdyj@163.com</span>
						</div>
						<div style="height: 30px;">
							<img src="@/assets/foot_3.png">
							<span> 技术: 封丘县环宇科技  电话: 13072697778</span>
						</div>
					</el-col>
					<el-col :span="6" class="el-col_bottom">
						<img src="@/assets/logo.png" style="width: 30%;">
					</el-col>
				</el-row>
			</div>
			<el-divider></el-divider>
			<div style="color: #FFFFFF;">
				<span>Copyright © 2022 河南省封丘县教师进修学校 版权所有</span>
			  <img src="@/assets/ghs.png">
			  <el-link href="http://beian.miit.gov.cn" target="_blank" >
				  <span style="color: #FFFFFF; font-size: 16px;">ICP备案号:豫ICP备2021027596号-1</span>
				</el-link>
			</div>
		</div>
		</div>
<!-- 		<div style="height: 350px; margin-top: -350px; background-color:rgba(25,130,204,0.8);">
			
		</div> -->
	</div>
</template>

<script>
	export default {
		data () {
			 return {
				 currentTime:'',//当前时间
				 }
			},
			created () {
				// this.getCurrentTime();
			},
			methods: {
				getCurrentTime(){
					setInterval(()=>{
				        //获取当前时间并打印
				           let y = new Date().getFullYear();
				           let m = new Date().getMonth() + 1;
				           let d = new Date().getDate();
				           let h = new Date().getHours();
				           let mm = new Date().getMinutes() < 10 ? "0" + new Date().getMinutes(): new Date().getMinutes();
				           let s =new Date().getSeconds() < 10 ? "0" + new Date().getSeconds() : new Date().getSeconds();
				           this.currentTime = y + "年" + m + "月" + d + "日" + "  " + h + ":" + mm + ":" + s;
					},500)
				    }
				}
			}
</script>

<style>
	.div1{
		background-image: url(../../public/Homebanner/banner_02.jpg);
		background-size: 100% 100%;
		/* background-repeat:repeat; */
		height: 300px;
		/* opacity: 0.8; */
	}
	.front{
		height: 300px;
		width: 100%;
		background-color: #1681CE;
		float: left;
		position: absolute;
		text-align: center;
		/* line-height: 300px; */
		opacity: 0.95;
	}
	.div2{
		display: table-cell;
		vertical-align: middle;
		text-align: center;
	}
	.el-col_bottom{
		height: 120px;
	    /* border: 1px solid red; */
	  }
	.divtime{
		background-color: #000080;
		color: #FFFFFF;
		width: 250px;
		margin-left: 17%;
		border-radius:30px;
	}  
</style>
